import React, { useEffect, useState } from 'react';
import { msRestantes } from '~/config/encerramentoSistema';
import { NumeroContador } from './styles';

const UM_SEGUNDO_EM_MS = 1000;

const doisDigitos = (valor: number): string => String(valor).padStart(2, '0');

/** Milissegundos → 'HH:MM:SS' (arredonda para cima: só mostra 00:00:00 no fim). */
const formatarTempo = (ms: number): string => {
  const totalSegundos = Math.ceil(ms / UM_SEGUNDO_EM_MS);
  const horas = Math.floor(totalSegundos / 3600);
  const minutos = Math.floor((totalSegundos % 3600) / 60);
  const segundos = totalSegundos % 60;

  return `${doisDigitos(horas)}:${doisDigitos(minutos)}:${doisDigitos(
    segundos,
  )}`;
};

interface ContadorRegressivoProps {
  /** Instante final (ms). */
  fim: number;
}

/**
 * Timer regressivo até `fim`. Atualiza a cada segundo só este componente, e
 * não a árvore da aplicação. É oculto para leitores de tela, para não anunciar
 * cada segundo: quem o usa deve exibir também a data/hora final em texto.
 */
const ContadorRegressivo: React.FC<ContadorRegressivoProps> = ({ fim }) => {
  const [restante, setRestante] = useState(() => msRestantes(fim));

  useEffect(() => {
    setRestante(msRestantes(fim));

    const intervalo = window.setInterval(
      () => setRestante(msRestantes(fim)),
      UM_SEGUNDO_EM_MS,
    );

    return () => window.clearInterval(intervalo);
  }, [fim]);

  return <NumeroContador aria-hidden>{formatarTempo(restante)}</NumeroContador>;
};

export default ContadorRegressivo;
